<template lang="pug">
include /mixins

+b.ti-stripe-view(
  style='padding: 20px'
)
  v-caption(size='5' variant='bold' style='padding-bottom: 20px') {{ _("c Stripe payment") }}
  +e.content
    +e.loader
    +e.form
      form#payment-form.form-loader
        #error-message
        #payment-element
          // Elements will create form elements here
        div#payment-request-button
        +e.button
          .card__panel.card__panel--offset_bottom
            +b.row--justification_end
              +b.cell.cols--12.--6-sm.--12-md.--6-xl
                +b.control-button--variant_success.--border_whole.BUTTON#submit(
                  style='margin-top: 12px'
                  :disabled='getCurrentTimer > 0 ? false : true'
                  type='submit'
                )
                  +e.element--size_lg
                    +b.caption--size_4.--variant_bold.SPAN {{ _('Pay now') }}

</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

import Checkbox from '@cabinet/components/forms/blocks/Checkbox'
import { successHandler, errorHandler } from '@cabinet/util'
import { Card, createToken } from 'vue-stripe-elements-plus'
import AutocompleteMixin from './../../../mixin/AutocompleteMixin'
import StripeBtn from '@cabinet/components/forms/StripeBtn'

import OrdersService from '@cabinet/services/api/orders'
import PaymentsService from '@cabinet/services/api/payments'
import UiSelect from '@cabinet/components/forms/blocks/UiSelect'
import UiCreditCardView from '@cabinet/components/forms/UiCreditCardView'

import StripePayment from '@cabinet/packages/stripe/src/main'
// import StripePayment from '@cabinet/packages/stripe/src/main'

export default {
  components: {
    UiCreditCardView,
    Checkbox,
    StripeCard: Card,
    StripeBtn,
    UiSelect,
  },

  props: {
    dataInfo: {
      type: Object
    },
    formData: {
      type: Object
    },
    totalPrice: {
      required: true
    },
    currency: {
      required: false,
      default: 'USD'
    },
    order: {},
    redirect: {},
    promise: {},
    total: {},
  },
  data() {
    return {
      complete: false,
      loading: false,

    }
  },
  async mounted() {

    this.createIntent()
  },
  computed: {
    ...mapState('userModule', ['userData']),
    ...mapGetters('cartModule', ['getCurrentTimer']),
    totalPriceConverted() {
      return parseFloat(this.total) * 100
    }
  },
  methods: {
    createIntent() {
      PaymentsService.createIntent(
        {
          currency: this.currency == "CA$" ? 'CAD' : 'USD', 
          amount: this.totalPriceConverted, 
          payment_parameters: {
            setup_future_usage: 'off_session',
            automatic_payment_methods: { enabled: true },
            confirm: false,
            payment_method_options: {
              'card': {
                'setup_future_usage': 'off_session',
              },
            }, 
          } ,
          "automatic_payment_methods": [
            "card",
          ],
          referer: window.location.href,
          cart: this.order.id,
          provider: this.order.provider,
        }
      ).then(({ data: { client_secret, payment } } ) => {
        this.stripeInstance = new StripePayment(this.totalPriceConverted, this.dataInfo.token, client_secret, this.order.id, 'payment-form', payment, this.redirect, {...this.formData, ...this.dataInfo})
        if (this.only_secure) {
          this.stripeInstance.loadSecureScript(this.order)
          this.opened = true
          return 
        }
        this.stripeInstance.loadScript()
        this.stripeInstance.complete()
        
        this.opened = true
      }, err => {
        const e = document.getElementById('error-message')
        console.log(e, err.response);
        if (e) {
          e.textContent = err.response.data.error
        }
        const p = document.getElementById('submit')
        p.style.display = 'none'
        const pf = document.getElementById('payment-form')
        pf.classList.remove('form-loader')
        

      })
    },
  }
}
</script>
